import { Link } from "react-router-dom";

/**
 * StoryComingSoon — shown when a specific article URL is visited
 * but the Issue 001 · Becoming Her articles haven't been published yet.
 * Same aesthetic as the Coming Soon hero.
 */
const StoryComingSoon = () => (
  <div
    className="bg-[var(--ih-ink)] text-[var(--ih-cream)] min-h-screen ih-grain relative flex flex-col"
    data-testid="story-coming-soon-root"
  >
    {/* subtle vignette */}
    <div
      className="absolute inset-0 pointer-events-none opacity-40"
      style={{
        background:
          "radial-gradient(ellipse at center, rgba(255,255,255,0.04) 0%, rgba(0,0,0,0) 55%, rgba(0,0,0,0.4) 100%)",
      }}
      aria-hidden="true"
    />

    <header className="relative max-w-[1100px] mx-auto w-full px-6 md:px-10 pt-8 flex items-center justify-between">
      <Link
        to="/"
        className="font-mono-ui text-[10px] uppercase tracking-[0.32em] ih-link"
        data-testid="story-coming-soon-back"
      >
        ← Back to Home
      </Link>
      <Link
        to="/"
        className="font-mono-ui text-[10px] uppercase tracking-[0.32em]"
      >
        The Inner Hustle
      </Link>
    </header>

    <main className="relative flex-1 flex items-center justify-center px-6 md:px-10 py-24">
      <div className="max-w-[820px] mx-auto text-center">
        <div
          className="w-10 md:w-14 h-[2px] mx-auto mb-10 md:mb-14"
          style={{ background: "var(--ih-accent)" }}
          aria-hidden="true"
        />

        <div
          className="font-mono-ui uppercase mb-8 md:mb-10"
          style={{
            fontSize: "clamp(0.72rem, 0.95vw, 0.86rem)",
            letterSpacing: "0.42em",
            color: "var(--ih-accent)",
          }}
        >
          Issue 001
        </div>

        <h1
          className="font-marquee leading-[0.95] tracking-[-0.01em]"
          style={{ fontSize: "clamp(2.8rem, 8vw, 7rem)" }}
          data-testid="story-coming-soon-title"
        >
          Becoming Her
        </h1>

        <div
          className="font-mono-ui uppercase mt-10 md:mt-14"
          style={{
            fontSize: "clamp(0.75rem, 1vw, 0.95rem)",
            letterSpacing: "0.5em",
            opacity: 0.75,
          }}
        >
          Coming Soon
        </div>

        <p
          className="mt-10 md:mt-12 font-display italic leading-[1.5] max-w-[520px] mx-auto"
          style={{
            fontSize: "clamp(1.05rem, 1.4vw, 1.25rem)",
            color: "var(--ih-cream)",
            opacity: 0.8,
          }}
        >
          This story is still being written. Join the Circle to be the first to read it when Issue 001 lands.
        </p>

        <Link
          to="/subscribe"
          className="mt-12 inline-flex items-center gap-2 font-mono-ui uppercase border-b pb-1 hover:gap-3 transition-all"
          style={{
            fontSize: "clamp(0.7rem, 0.85vw, 0.8rem)",
            letterSpacing: "0.42em",
            borderColor: "var(--ih-accent)",
            color: "var(--ih-cream)",
          }}
          data-testid="story-coming-soon-cta"
        >
          Be the first to read it
          <span aria-hidden>→</span>
        </Link>
      </div>
    </main>

    <footer className="relative max-w-[1100px] mx-auto w-full px-6 md:px-10 pb-8 pt-6 border-t border-[var(--ih-cream)]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 font-mono-ui text-[10px] uppercase tracking-[0.42em] text-[var(--ih-cream)]/60">
      <div>© 2026 The Inner Hustle</div>
      <div>Move differently.</div>
    </footer>
  </div>
);

export default StoryComingSoon;
